import { useEffect, useMemo, useRef } from "react";

import { Extensions } from "@tiptap/react";

import DotPhraseFields from "../tiptap/dot-phrase-fields";
import DotPhraseSuggestion from "../tiptap/dot-phrase-suggestion";
import { buildDotPhraseSuggestionRender } from "../tiptap/dot-phrase-suggestion-renderer";
import { dotPhraseInsertCommand } from "../tiptap/insert-dot-phrase";

import useInsertableDotPhrases from "./useInsertableDotPhrases";

export default function useDotPhraseSuggestionExtension(isDisabled = false): Extensions {
  const dotPhrases = useInsertableDotPhrases();
  const dotPhrasesRef = useRef(dotPhrases);
  const isTriggerEnabledRef = useRef(!isDisabled);

  useEffect(() => {
    dotPhrasesRef.current = dotPhrases;
  }, [dotPhrases]);

  useEffect(() => {
    isTriggerEnabledRef.current = !isDisabled;
  }, [isDisabled]);

  return useMemo(
    () => [
      DotPhraseSuggestion.configure({
        getDotPhrases: () => dotPhrasesRef.current,
        getIsTriggerEnabled: () => isTriggerEnabledRef.current,
        render: buildDotPhraseSuggestionRender(),
        command: dotPhraseInsertCommand,
      }),
      DotPhraseFields,
    ],
    [],
  );
}
